import axios, { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { bootstrapConfig } from '~src/config/bootstrap-config';
import { bundledConfig } from '~src/config/bundled-config';

export function countryNamesLocalizationGet(locale: string) {
  return axios.get<Record<string, string>>(
    `${bundledConfig.cdnUrl}/country-names-locales/${locale}.json`
  );
}

export function useCountryNamesLocalizationQuery() {
  return useQuery<Record<string, string>, AxiosError>({
    queryKey: ['country-names'],
    queryFn: async () => {
      const { data } = await countryNamesLocalizationGet(bootstrapConfig.locales[0]);
      return data;
    },
  });
}
